import theme from '@/theme';
import { IProjectTemplate } from '@d-id/types';
import styled from '@emotion/styled';
import { useCallback, useRef } from 'react';

export const TemplateTileContainer = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    border: 1px solid ${theme.colors.black[300]};
    cursor: pointer;
`;

const ScenesCountTag = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 8px;
    left: 8px;
    padding: 2px 8px;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.black[100]};
    color: ${({ theme }) => theme.colors.secondary.main};
`;

const StyledVideo = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
    box-shadow: 0px 1.32px 1.32px 0px rgba(0, 0, 0, 0.1);
`;

interface Props {
    template: IProjectTemplate;
    onClick: () => void;
}

export const TemplateTile = ({ template, onClick }: Props) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    const handleMouseEnter = useCallback(() => {
        if (!videoRef.current) return;
        videoRef.current.play();
    }, []);

    const handleMouseLeave = useCallback(() => {
        if (!videoRef.current) return;
        videoRef.current.pause();
        videoRef.current.currentTime = 0; // Reset video to the start
    }, []);

    return (
        <TemplateTileContainer key={template.id} onClick={onClick} data-testid="template-tile">
            <StyledVideo
                ref={videoRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                src={template.previewUrl}
                poster={template.scenesThumbnailsUrls[0]}
                muted
                loop
            />

            <ScenesCountTag data-testid={`template-tile-scenes-count-${template.scenesCount}`}>
                {`${template.scenesCount} ${template.scenesCount > 1 ? 'scenes' : 'scene'}`}
            </ScenesCountTag>
        </TemplateTileContainer>
    );
};
